/**
 * Created by lycheng on 2017/11/23.
 * 复选框
 */
function init () {
  $('body').on('change', '.checkbox-box input[type=checkbox]', function () {
    var checked = this.checked
    var $box = $(this).parents('.checkbox-box')
    if (checked) {
      $box.addClass('checked')
    } else {
      $box.removeClass('checked')
    }
  })
}
init()



// WEBPACK FOOTER //
// ./src/js/libs/utils-checkbox.js